import { authApi } from "./auth";
import { charactersApi } from "./characters";
import { driveApi } from "./drive";
import { gameApi } from "./game";
import { lessonApi } from "./lessons";
import { systemApi } from "./system";
import { worksheetApi } from "./worksheet";

export const papi = {
	auth: authApi,
	character: charactersApi,
	drive: driveApi,
	game: gameApi,
	lesson: lessonApi,
	system: systemApi,
	worksheet: worksheetApi
}